import { render, staticRenderFns } from "./ConfigEdit.vue?vue&type=template&id=3d2a37ee&scoped=true"
import script from "./ConfigEdit.vue?vue&type=script&lang=js"
export * from "./ConfigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a37ee",
  null
  
)

export default component.exports